import BaseService from "@/boot/BaseService";
class AutoAgendamientoService extends BaseService {
  constructor() {
    super(null, "/autoagendamiento");
  }
  async index(params) {
    return await this.get("/", params);
  }

  async show(id) {
    return await this.get(`/${id}`);
  }
}

export default new AutoAgendamientoService();
